module.exports = __webpack_public_path__ + "img/plus_member.21b55e93.png";